import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../ui';

/**
 * PromptStats - Sidebar statistics and author info
 * Simplified and extracted from PromptDetail
 */
const PromptStats = ({ prompt, ratingStats }) => {
  return (
    <div className="space-y-6">
      {/* Rating Statistics */}
      {ratingStats && (
        <Card padding="comfortable">
          <h3 className="text-lg font-semibold mb-4 dark:text-white">Rating Statistics</h3>
          <div className="space-y-3">
            <StatBar
              label="Average"
              value={parseFloat(ratingStats.average_rating) || 0}
              color="bg-boop-primary"
            />
            <StatBar
              label="Clarity"
              value={parseFloat(ratingStats.avg_clarity) || 0}
              color="bg-blue-500"
            />
            <StatBar
              label="Creativity"
              value={parseFloat(ratingStats.avg_creativity) || 0}
              color="bg-purple-500"
            />
            <StatBar
              label="Effectiveness"
              value={parseFloat(ratingStats.avg_effectiveness) || 0}
              color="bg-green-500"
            />
          </div>
        </Card>
      )}

      {/* Author Info */}
      <Card padding="comfortable">
        <h3 className="text-lg font-semibold mb-4 dark:text-white">About the Author</h3>
        <Link
          to={`/profile/${prompt.username}`}
          className="flex items-center mb-4 hover:opacity-80 transition"
        >
          <div className="w-12 h-12 bg-boop-light dark:bg-spooky-bg-light rounded-full flex items-center justify-center text-xl font-bold text-boop-primary mr-3">
            {prompt.username?.[0]?.toUpperCase()}
          </div>
          <div>
            <div className="font-semibold dark:text-white">
              {prompt.display_name || prompt.username}
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-400">@{prompt.username}</div>
          </div>
        </Link>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="flex items-center justify-between">
            <span>Level:</span>
            <span className={`level-badge level-${prompt.level || 'B'}`}>
              {prompt.level || 'B'}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span>Created:</span>
            <span>{new Date(prompt.created_at).toLocaleDateString()}</span>
          </div>
        </div>
      </Card>
    </div>
  );
};

/**
 * StatBar - Progress bar for rating statistics
 */
const StatBar = ({ label, value, color }) => {
  const percentage = (value / 10) * 100;

  return (
    <div>
      <div className="flex justify-between text-sm mb-1">
        <span className="dark:text-white">{label}</span>
        <span className="font-bold dark:text-white">{value.toFixed(1)}/10</span>
      </div>
      <div className="w-full bg-gray-200 dark:bg-spooky-bg-light rounded-full h-2">
        <div
          className={`${color} h-2 rounded-full transition-all duration-300`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default PromptStats;
